/* import moment from 'moment'; */
import React from 'react';
import PropTypes from 'prop-types';
import WindowLayout from '../WindowLayout';
import WindowOptions from '../WindowOptions';
import WindowIconTitle from '../WindowIconTitle';
import Icon from '../Icon';
import FileManagerLayouter from '../FileManagerLayouter';
import { FormattedHTMLMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { RESULTSDOCUMENT } from '../../routes';
import { formatRoute } from 'react-router-named-routes';
import ExportResults from '../ExportResults';

const Results = ({ game, history }) => (
	<WindowLayout>
		<WindowLayout.Header>
			<WindowOptions history={history} />
			<WindowIconTitle icon={'folder'} title={'Results'} />
		</WindowLayout.Header>
		<WindowLayout.Body>
			<FileManagerLayouter>
				<FormattedHTMLMessage id="results" />
				<FormattedHTMLMessage id="documents-description" />
				{game.state === 'COMPLETED' && (
					<NavLink to={formatRoute(RESULTSDOCUMENT, { gameID: game.id })}>
						<Icon icon={'docdocument'} />
						<span className="medium-font">
							<FormattedHTMLMessage id="results" />
						</span>
					</NavLink>
				)}
				{/* 
					game
						.businessPlans
						.filter( (bp, index) => ((index+1 < game.lastSubmission) || ((game.state === 'COMPLETED') && (index+1 <= game.lastSubmission)) ) )
						.map( (businessPlan,index) => (
							<ExportResults key={index} businessPlan={businessPlan}>
								<Icon icon={'xlsxdocument'} />
								<span className="medium-font">
                  Submission {index+1}
									<br />
									{businessPlan.submittedAt && moment(businessPlan.submittedAt).format('DD/MM/YYYY-hh:mm')}
								</span>
							</ExportResults>
						)) */
				}
				{
					/* game
						.businessPlans
						.filter( (bp, index) => ((index+1 < game.lastSubmission) || ((game.state === 'COMPLETED') && (index+1 <= game.lastSubmission)) ) )
						.map( (businessPlan,index) => ( */
					<ExportResults game={game}>
						<Icon icon={'xlsxdocument'} />
						<span className="medium-font">
                  Submissions
							<br />
						</span>
					</ExportResults>
					/* )) */
				}
			</FileManagerLayouter>
		</WindowLayout.Body>
	</WindowLayout>
);

Results.propTypes = {
	game: PropTypes.shape({
		match: PropTypes.shape({
			businessPlans: PropTypes.shape({
				id: PropTypes.string,
				name: PropTypes.string,
				submittedAt: PropTypes.string
			})
		})
	})
};

export default Results;
